import { useEffect, useState } from 'react';
import * as S from './styles';

interface DropdownProps {
  isOpen: boolean;
  options: React.ReactNode;
  parentRef: React.RefObject<HTMLDivElement>;
}

const offset = 4;

export const Dropdown: React.FC<DropdownProps> = ({ isOpen, options, parentRef }) => {
  const [dropdownPosition, setDropdownPosition] = useState<{ top: number; left: number; width: number }>({
    top: 0,
    left: 0,
    width: 0,
  });

  useEffect(() => {
    const updatePosition = () => {
      if (!parentRef.current) return;
      const rect = parentRef.current.getBoundingClientRect();
      setDropdownPosition({
        top: rect.height + offset,
        left: 0,
        width: rect.width,
      });
    };

    updatePosition(); // на открытие

    if (isOpen) {
      window.addEventListener('scroll', updatePosition);
      window.addEventListener('resize', updatePosition);
    }

    return () => {
      window.removeEventListener('scroll', updatePosition);
      window.removeEventListener('resize', updatePosition);
    };
  }, [isOpen, parentRef]);

  return (
    <S.Dropdown isOpen={isOpen} top={dropdownPosition.top ?? 0} left={dropdownPosition.left ?? 0} width={dropdownPosition.width ?? 0}>
      {options}
    </S.Dropdown>
  );
};
